import React, { useState } from "react"
import classNames from "classnames"
import { Link, useStaticQuery, graphql } from "gatsby"

import "./menu.css"

const MenuItem = ({ to, text, className }) => (
  <li className={`menu__item ${className}`}>
    <Link to={to} className="menu__link">
      {text}
    </Link>
  </li>
)

const getHierarchy = items => {
  let hierarchy = []
  let parents = {}

  items.forEach(item => {
    if (item.submenu) {
      hierarchy.push({
        text: item.text,
        items: [],
      })
      parents[item.text] = hierarchy.length - 1

      return
    }

    if (item.text === "") {
      console.error(
        'Menu item attribute "text" is not set. Skipping item',
        item
      )

      return
    }

    if (item.to === "") {
      console.error('Menu item attribute "to" is not set. Skipping item', item)

      return
    }

    if (item.parent === "") {
      hierarchy.push(item)

      return
    }

    const parentIndex = parents[item.parent]

    if (parentIndex === undefined) {
      console.error(
        `Can't find menu item parent. Parent index undefined. Adding item in top hierarchy instead.`,
        item
      )
      hierarchy.push(item)
    }

    const parentItem = hierarchy[parentIndex]

    if (parentItem === undefined || !(parentItem.items instanceof Array)) {
      console.error(
        `Can't find menu item parent. Parent items undefined. Adding item in top hierarchy instead.`,
        item
      )
      console.error("ParentItem:", parentItem)
      hierarchy.push(item)
    }

    parentItem.items.push(item)
  })

  return hierarchy
}

const Menu = () => {
  const [active, setActive] = useState(false)

  const buttonClasses = classNames("hamburger-button", {
    "hamburger-button--active": active,
  })
  const menuClasses = classNames("menu", {
    "menu--active": active,
  })

  const toggleMenu = () => {
    setActive(!active)
  }

  const data = useStaticQuery(graphql`
    {
      allGoogleSheetMenyRow {
        edges {
          node {
            text
            lank
            foralder
            undermeny
          }
        }
      }
    }
  `)

  const menuItems = data.allGoogleSheetMenyRow.edges.map(edge => ({
    text: edge.node.text,
    to: edge.node.lank,
    parent: edge.node.foralder,
    submenu: edge.node.undermeny,
    id: edge.node.id,
  }))

  const menuHierarchy = getHierarchy(menuItems)

  return (
    <>
      <button
        className={buttonClasses}
        onClick={toggleMenu}
        aria-label="Öppna eller stäng menyn"
      >
        <div className="hamburger-button__lines">
          <span className="hamburger-button__line hamburger-button__line--top"></span>
          <span className="hamburger-button__line hamburger-button__line--middle"></span>
          <span className="hamburger-button__line hamburger-button__line--bottom"></span>
        </div>
      </button>
      <nav className={menuClasses}>
        <ul className="menu-items">
          {menuHierarchy.map((item, index) => {
            if (item.items instanceof Array) {
              // Render submenu with its items
              return (
                <li className="menu__item" key={index}>
                  <details className="submenu">
                    <summary className="submenu__heading" aria-label="submenu">
                      {item.text} <i className="arrow arrow--down"></i>
                    </summary>
                    <ul className="submenu__items">
                      {item.items.map((subItem, subIndex) => (
                        <MenuItem
                          to={subItem.to}
                          key={subIndex}
                          text={subItem.text}
                          className="menu__item--indented"
                        />
                      ))}
                    </ul>
                  </details>
                </li>
              )
            } else {
              return <MenuItem to={item.to} key={index} text={item.text} />
            }
          })}
        </ul>
      </nav>
    </>
  )
}

export default Menu
